// Totes On Time — ZIP Lookup
// Security notes:
//  - All user input is sanitized with regex before use
//  - All DOM output uses textContent (never innerHTML) to prevent XSS
//  - ZIP database is loaded from same-origin /assets/ (no external fetch)
//  - No eval, no dynamic script injection, no inline event handlers
(function () {
  'use strict';

  // Load ZIPs from Shopify's CDN-rendered URL (passed via data attribute on the section)
  // Falls back to /assets/ for local preview
  function loadZips(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('ZIP data unavailable');
        return r.json();
      })
      .catch(function () { return null; });
  }

  // Strict input sanitization: only allow 5 digits
  function sanitizeZip(raw) {
    if (typeof raw !== 'string') return '';
    var digits = raw.replace(/[^0-9]/g, '').slice(0, 5);
    return digits.length === 5 ? digits : '';
  }

  function setResult(el, message, status) {
    if (!el) return;
    // textContent is XSS-safe — never use innerHTML for dynamic data
    el.textContent = message;
    el.setAttribute('data-status', status); // 'ok' | 'no' | 'error' | ''
  }

  function init() {
    var sections = document.querySelectorAll('.zip-lookup[data-zip-asset], .zip-lookup');
    if (!sections.length) return;

    sections.forEach(function (section) {
      // Get the data URL — section attribute first, fallback for local preview
      var assetUrl = section.getAttribute('data-zip-asset') || '/assets/oc-zips.json';
      var zipsPromise = loadZips(assetUrl);

      var forms = section.querySelectorAll('[data-zip-form]');
      forms.forEach(function (form) {
        var input = form.querySelector('[data-zip-input]');
        var btn = form.querySelector('[data-zip-check]');
        var result = section.querySelector('[data-zip-result]');
        if (!input || !btn) return;

      function handleCheck() {
        var clean = sanitizeZip(input.value);
        if (!clean) {
          setResult(result, 'Please enter a valid 5-digit ZIP code.', 'error');
          return;
        }

        zipsPromise.then(function (data) {
          if (!data || !data.zips) {
            setResult(result, 'Unable to verify right now. Please call us to confirm.', 'error');
            return;
          }
          var city = Object.prototype.hasOwnProperty.call(data.zips, clean) ? data.zips[clean] : null;
          if (city) {
            setResult(result, '✓ Yes! We deliver to ' + city + ' (' + clean + '). Reserve your totes below.', 'ok');
          } else {
            setResult(result, "We don't currently serve " + clean + '. Sign up below and we\'ll let you know when we expand.', 'no');
          }
        });
      }

      btn.addEventListener('click', handleCheck);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleCheck();
        }
      });
      // Auto-strip non-digits as they type
      input.addEventListener('input', function () {
        var clean = input.value.replace(/[^0-9]/g, '').slice(0, 5);
        if (clean !== input.value) input.value = clean;
      });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
